export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </span>
              <span className="text-lg font-bold font-heading">日韩影视网</span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              日韩影视网为您汇集日剧全集、韩剧全集等海量高清资源。每日同步更新最新日韩电视剧，高清不缓冲在线观看，让追剧成为一种享受。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold font-heading mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">首页</a>
              <a href="#ranking" className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">热播榜单</a>
              <a href="#topics" className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">热门话题</a>
              <a href="#carousel" className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">专题推荐</a>
              <a href="#faq" className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">常见问题</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold font-heading mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#media" className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">日剧全集</a>
              <a href="#media" className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">韩剧全集</a>
              <a href="#index" className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">爱情剧场</a>
              <a href="#index" className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">悬疑推理</a>
              <a href="#index" className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">古装历史</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold font-heading mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              诚邀优质内容方与广告合作伙伴加入，共同打造华语地区领先的日韩影视平台。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 text-white/60 hover:text-white transition-all duration-200 cursor-pointer">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 text-white/60 hover:text-white transition-all duration-200 cursor-pointer">
                <i className="ri-mail-line text-base"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; 2020-2026 日韩影视网. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-white/40">
            <a href="#about" className="hover:text-white/70 transition-colors duration-200 whitespace-nowrap">关于我们</a>
            <a href="#contact" className="hover:text-white/70 transition-colors duration-200 whitespace-nowrap">联系我们</a>
            <a href="#faq" className="hover:text-white/70 transition-colors duration-200 whitespace-nowrap">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}